import React, { Component } from "react";
import ListView from "../../components/ListView";

import { Customer } from "../../../redux/modules/customers/reducer";
import { AclState } from "../../../acl/reducer";
import { GlobalState } from "../../../redux/modules/rootReducer";
import { style } from "typestyle";
import { customerHasPermissions } from "../../../acl/utils";
import { connect } from "react-redux";
import { GrayDark } from "@traceair/tds";

type CustomersListProps = {
  customers: Customer[];
  onCustomerClick: (customerId: string) => void;
  acl: AclState;
};
class CustomersList extends Component<CustomersListProps> {
  handleRowClick = (row: Customer) => {
    this.props.onCustomerClick(row.id);
  };

  render() {
    return (
      <ListView
        leftColumnHeader={"Customer Name"}
        rightColumnHeader={null}
        rows={this.props.customers}
        renderLeftColumn={this.renderLeftColumn}
        renderRightColumn={this.renderRightColumn}
        onRowClick={this.handleRowClick}
        onSort={rows =>
          rows.sort((a, b) => {
            if (a.name.toLowerCase() === b.name.toLowerCase()) {
              return 0;
            }

            return a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1;
          })
        }
      />
    );
  }

  renderLeftColumn = (row: Customer) => {
    const { acl } = this.props;
    const viewCustomerIdPermitted = customerHasPermissions(
      acl,
      ["BACKOFFICE_CUSTOMER_SYSTEM_ID_VIEW"],
      row.id,
    );
    return (
      <div>
        <div
          className={style({
            fontSize: "20px",
            lineHeight: "26px",
          })}
        >
          {row.name}
        </div>
        {viewCustomerIdPermitted && (
          <div
            className={style({
              color: GrayDark,
              fontSize: "14px",
              lineHeight: "18px",
            })}
          >
            {row.id}
          </div>
        )}
      </div>
    );
  };

  renderRightColumn = () => {
    return <div />;
  };
}

export default connect((state: GlobalState, ownProps) => {
  return {
    ...ownProps,
    acl: state.acl,
  };
})(CustomersList);
